import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import HartuCancelationButton from '../../atoms/HartuCancelationButton/HartuCancelButton'
import PageRow from '../../atoms/PageRow/PageRow'
import HartuBookingGrid from '../../components/Hartu/HartuBookingGrid/HartuBookingGrid'
import ThankYouPage from '../../compositions/ThankYouPage/ThankYouPage'
import FailPage from '../../compositions/FailPage/FailPage'
import STATES from '../../constants/states'
import t from '../../i18n/translations/translations'
import {
    getAvailableDatesByFacilityAndType,
    getAvailableHoursByFacilityAndType,
    saveHartuFacilityBooking as saveHartuFacilityBookingAction,
    setHartuFacilityDetail as setHartuFacilityDetailAction,
} from '../../store/actions'

function HartuBookingContainer({ isMobile, isTablet, match }) {
    const dispatch = useDispatch()

    const {
        availableDates,
        bookingFormState,
        datesLoading,
        errorBookingCode,
        facility,
        facilityHoursAvailable,
        hasDiscountsFacility,
        discountAvailable,
        facilityData,
        formValuesBooking,
        hoursLoading,
        instanceID,
        price,
        defaultPrice,
        bestDiscountEs,
        bestDiscountEu
    } = useSelector((state) => ({
        availableDates: state.hartu.dates?.data,
        bookingCode: state.hartu.booking?.data?.data?.booking_code,
        bookingFormState: state.hartu.bookingFormState,
        date: state.hartu.booking?.data?.data?.date,
        datesLoading: state.hartu.datesLoading,
        errorBookingCode: state.hartu.booking?.data?.code,
        facility: state.hartu.facility,
        facilityHoursAvailable: state.hartu.hours?.data?.data,
        hasDiscountsFacility: state.hartu.facility?.data?.data?.has_discounts_facility,
        defaultPrice: state.hartu.facility?.data?.data?.default_prize,
        discountAvailable: state.hartu.facility?.data?.data?.discount_available,
        bestDiscountEs: state.hartu.facility?.data?.data?.best_discount_es,
        bestDiscountEu: state.hartu.facility?.data?.data?.best_discount_eu,
        facilityData: state.hartu.facility?.data?.data,
        facilityName: state.hartu.booking?.data?.data?.facility_name,
        formValuesBooking: state.hartu.booking?.bookingSave,
        hoursLoading: state.hartu.hoursLoading,
        instanceID: state.pages.hartu?.data[0]?.idinstancia,
        price: state.hartu.facility?.data?.data?.user_prize?.price
    }))
    const getAvailableDates = (payload) =>
        dispatch(getAvailableDatesByFacilityAndType(payload))
    const getAvailableHours = (payload) =>
        dispatch(getAvailableHoursByFacilityAndType(payload))
    const saveHartuFacilityBooking = (payload) =>
        dispatch(saveHartuFacilityBookingAction(payload))
    const setHartuFacilityDetail = (payload) =>
        dispatch(setHartuFacilityDetailAction(payload))
    
    const userId = sessionStorage.getItem('uzky');

    const [showBanner, setShowBanner] = useState(true);
    const handleHideDiscount = () => {
        setShowBanner(false);
    };
    
    useEffect(() => {
        const { lang, facilityID, facilityType } = match

        if (facilityID && instanceID && lang) {
            setHartuFacilityDetail({
                facilityID,
                facilityType,
                idInstancia: instanceID,
                lang,
                userId,
            })
        }
    }, [])

    const { lang, date: paramsDate } = match
    return bookingFormState === STATES.SUCCESS ? (
        <ThankYouPage
            match={match}
        >
        </ThankYouPage>
    ) : bookingFormState === STATES.ERROR ? (
    
        <FailPage  
            match={match}
        >
        </FailPage>
    ) : (
        <>
            {facilityData ? (
                <div>
                <div className={`${isMobile || isTablet ? '' : 'pageRow'}`}>
                    <HartuBookingGrid
                        availableDates={availableDates}
                        bookingFormState={bookingFormState}
                        data={facilityData}
                        datesLoading={datesLoading}
                        errorBookingCode={errorBookingCode}
                        facility={facility}
                        hasDiscountsFacility={hasDiscountsFacility}
                        facilityHoursAvailable={facilityHoursAvailable}
                        formValuesBooking={
                            formValuesBooking || facilityData['user_prize']
                        }
                        getAvailableDates={getAvailableDates}
                        getAvailableHours={getAvailableHours}
                        hoursLoading={hoursLoading}
                        instanceID={instanceID}
                        lang={lang}
                        defaultPrice={defaultPrice}
                        paramsDate={paramsDate}
                        saveHartuFacilityBooking={saveHartuFacilityBooking}
                        handleHideDiscount={handleHideDiscount} 
                    />
                </div>
                    {showBanner && (<div className="pageRow hartuBookingGrid__discount_box">
                        {hasDiscountsFacility && !userId && price != 0 && (
                            <span className="hartuBookingGrid__discount">{t.logout_has_discounts[lang]}</span>
                        )}
                        {hasDiscountsFacility && userId && price != 0 && discountAvailable && lang == "es" ? (
                            <span
                                className="hartuBookingGrid__discount"
                                dangerouslySetInnerHTML={{
                                    __html: bestDiscountEs,
                                }}
                            />
                        ) : hasDiscountsFacility && userId && price != 0 && discountAvailable && lang == "eu" ?(
                            <span
                                className="hartuBookingGrid__discount"
                                dangerouslySetInnerHTML={{
                                    __html: bestDiscountEu,
                                }}
                            />
                        ) : null}
                    </div>)}
                </div>
            ) : null}
            <PageRow>
                <HartuCancelationButton lang={lang} />
            </PageRow>
        </>
    )
}

export default HartuBookingContainer
